import { render, staticRenderFns } from "./AppCheckbox.vue?vue&type=template&id=4e0cd877&scoped=true&"
import script from "./AppCheckbox.vue?vue&type=script&lang=js&"
export * from "./AppCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./AppCheckbox.vue?vue&type=style&index=0&id=4e0cd877&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0cd877",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
